import styled from 'styled-components';
import rewardsIcon from '../../assets/icons/header/rewards_icon.png';

const RewardsButton = styled.button(({ theme }) => {
  const { color, type } = theme;

  return `
    background-color: ${color.accentPrimary.light};
    color: ${color.grayscale[0]};
    padding: 1rem 1rem 1rem 4rem;
    border-radius: 50px;
    font-size: ${type.size.small};
    line-height: 1.143;
    font-family: ${type.face};
    font-weight: 600;
    position: relative;

    &:hover {
      text-decoration: none;
      color: ${color.primary.regular};
    }

    &::after {
      content: url(${rewardsIcon});
      display: block;
      position: absolute;
      left: 0;
      top: -0.25rem;
      height: 3.5rem;
      width: 3.5rem;
    }
  `;
});

export default RewardsButton;
